// 261029 P1 B2(c) — nạp bối cảnh + báo cáo ảnh cũ SONG SONG (trước: nối tiếp). Mỗi nguồn giữ fallback riêng như cũ: lỗi `getWorldSetting` ⇒ `resolved=null`; lỗi `stale` ⇒ `items=[]`.
// THUẦN (không antd) ⇒ test được dưới jest.
export interface WorldStaleApi<W, S> {
  getWorldSetting: (planId: string) => Promise<W>;
  getStaleAssets: (planId: string) => Promise<{ items?: S[] }>;
}
export async function loadWorldAndStale<W, S>(planId: string, api: WorldStaleApi<W, S>): Promise<{ resolved: W | null; staleItems: S[] }> {
  const worldP = api.getWorldSetting(planId);
  const staleP = api.getStaleAssets(planId);
  worldP.catch(() => undefined); staleP.catch(() => undefined);   // cả hai đã khởi: lỗi nguồn kia không thành unhandled rejection
  let resolved: W | null;
  try { resolved = await worldP; } catch { resolved = null; }       // truyện chưa khai / plan lỗi — không làm vỡ cả drawer
  let staleItems: S[];
  try { staleItems = (await staleP).items || []; } catch { staleItems = []; }
  return { resolved, staleItems };
}
